import type { ApprovalStatus } from 'cmp-client-api';
import type { ServiceModuleDeploymentApiInterface } from '@src/server';
import type { SupportTicketInterface } from '@src/domain/types';

export enum KnownServiceRequestTypes {
  GENERAL = 'general',
  // Preserving "dashboard" naming. Changing this requires DB migrations
  REPORT = 'dashboard',
}
export type ServiceRequestTypes = KnownServiceRequestTypes | string;

// FIXME: according to a screenshot on the ticket,
// there should be a timestamped status history,
// not just a current status
// https://softwareone.atlassian.net/browse/GOR-547

export interface ServiceRequestInterface {
  id: string;
  customerTenantId: string;
  title: string;
  description?: string;
  deploysServiceModule: boolean;
  organizationId?: string;
  serviceModuleDeployment?: ServiceModuleDeploymentApiInterface;
  serviceRequestStatus: ApprovalStatus;
  supportSystem: SupportTicketInterface;
  updatedAt: string;
  createdAt: string;
  email: string;
  requestType?: ServiceRequestTypes;
}
